import * as React from "react"
import './tooltip.scss'
import { classNames } from "../../utils"

interface ITooltipProps {
    text: string
    open: boolean
    right?: React.CSSProperties["right"]
    style?: React.CSSProperties
    onClick?: (evemt: React.MouseEvent) => void
}

const Tooltip: React.FC<ITooltipProps> = props => {
    const { text, open, right, style, onClick } = props

    return (
        <React.Fragment>
            <div
                className={classNames({
                    "app-tooltip": true,
                    "app-tooltip--hide": !open
                })}
                style={style} >

                <div className="app-tooltip__bubble">
                    <p>{text}</p>
                    <div className="app-tooltip__arrow" style={{ right: right || 15 }}></div>
                </div>
            </div >
            <span
                className="app-tooltip__dot"
                style={{ ...style, right: right || 15 }}
                onClick={onClick}
            >i</span>
        </React.Fragment>
    )
}

export default Tooltip